import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";
import type { AxiosError } from "@api/types.ts";
import type {
  IReportDownloadEndpoint,
  IReportDownloadParams,
} from "@api/reports/types";

const { key, getPath } = getApi("reports.medicalServiceAssign.get");

type IResponse = AxiosResponse<IApiResponse<IReportDownloadEndpoint>>;
type IVariables = IReportDownloadParams;

export const getMedicalServiceAssignReport: IAxiosFn<
  IVariables,
  IResponse
> = async (params, signal) => {
  return axiosClient.get(getPath(), {
    params,
    signal,
  });
};

export const useGetMedicalServiceAssignReport = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getMedicalServiceAssignReport(variables, signal),
});
